import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem, {ListItemProps} from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CustomMuiButton from '../../01_atoms/CustomMuiButton';

const useStyles = makeStyles((theme) => ({
      navTitle: {
        padding: 0,
        color: theme.palette.warning.main,
      },
      sideItem: {
        color: theme.palette.warning.main,
        borderBottom: 'solid thin',
        borderColor: theme.palette.warning.main,
        paddingLeft: 0,
        margin: 0,


      },
      sideItemText: {
        margin: 0,
        padding: 0,
        "& span": {
          fontSize: 24,
          margin: 0,
          color: 'white',
          fontWeight: 400,
          fontFamily: 'Raleway',
        },
      },
    }),
);

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

export default function SideNav(props) {
  const classes = useStyles(props);
  let {
    items,
    showButton,
    blockTitle,
    titleColor,
  } = props;
  if (!items) {
    return null;
  }

  return (
      <Box px={3} py={2} bgcolor="grey.700">
        <Box color={titleColor}>
          <Typography className={classes.navTitle} variant="h5"
                      component="h4"><strong>{blockTitle}</strong></Typography>
        </Box>
        <List component="nav" aria-label="item list">
          {items.map((listItem, ind) => {
            return (
                <ListItemLink className={classes.sideItem} key={`item--${ind}`}
                              href={listItem.linkUrl}>
                  <ListItemText className={classes.sideItemText}
                                primary={listItem.linkText}/>
                </ListItemLink>
            );
          })}

        </List>
        {showButton &&
        <Box align="center" pt={4}>
          <CustomMuiButton href={`/blog`} size="large" color="default"
                           label={"ALL ARTICLES"}></CustomMuiButton>
        </Box>
        }
      </Box>
  );
};
